export default __webpack_public_path__ + "static/media/empty_table_img.5ba7a556.svg";